import { render } from "./BotId.vue?vue&type=template&id=797b7bc6&scoped=true"
import script from "./BotId.vue?vue&type=script&lang=js"
export * from "./BotId.vue?vue&type=script&lang=js"

import "./BotId.vue?vue&type=style&index=0&id=797b7bc6&scoped=true&lang=css"

import exportComponent from "/app/widget-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-797b7bc6"]])

export default __exports__